import libraryTemplateGet, {
  LibraryTemplateGetResponse,
} from '@/lib/request/webapp/people/library-template-get';
import usePeopleStore from '@/modules/people/store';
import useRootStore from '@/modules/people/store/root';

export default async function getLibraryTemplateById(
  awardId: string | number
): Promise<LibraryTemplateGetResponse> {
  if (!awardId && awardId !== 0) {
    throw new Error('Award id is required');
  }

  const params: { awardId?: number; newAwardId?: string } = {
    awardId: undefined,
    newAwardId: undefined,
  };

  const intAwardId = Number(awardId);

  if (!isNaN(intAwardId)) {
    params.awardId = intAwardId;
  } else {
    const peopleState = usePeopleStore();
    const rootState = useRootStore();
    let newAwardId = String(awardId);

    if (peopleState.isPayPolicy(awardId)) {
      const selectedEmploymentTerm = rootState.getEmploymentTermById(awardId);

      newAwardId = String(
        selectedEmploymentTerm.TermId || selectedEmploymentTerm.Id
      );
    }

    params.newAwardId = newAwardId;
  }

  return libraryTemplateGet(params);
}
